import type {UseMutationResult} from '@tanstack/react-query';
import {useMutation, useQueryClient} from '@tanstack/react-query';
import useApiFetch from '@/components/MSAL/useApiFetch';
import {apiUrl} from '@/utils/api';

type MutateSearchCriteriaParams = {
    associateId : number;
    labelId : number;
};

export const useDeleteCapacityFutureTime = () : UseMutationResult<
    void,
    unknown,
    MutateSearchCriteriaParams
> => {
    const fetch = useApiFetch();
    const queryClient = useQueryClient();

    return useMutation(async (mutateSearchCriteriaParams : MutateSearchCriteriaParams) : Promise<void> => {
        const {associateId, labelId} = mutateSearchCriteriaParams;

        try {
            await fetch(apiUrl('/v1/capacity/capacity/delete-future-time').toString(), {
                method: 'DELETE',
                body: JSON.stringify({
                    associateId: associateId,
                    timeLabelId: labelId,
                }),
            });
        } catch (e : unknown) {
            throw new Error('Unable to delete capacity default.');
        }
    }, {
        onSuccess: async () => {
            await queryClient.invalidateQueries(['capacityCombined']);
        },
    });
};
